// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import FitTextToBounds from "../core/components/FitTextToBounds";
import LocaliseText from "../core/components/LocaliseText";
/* START-USER-IMPORTS */
import { Character, CharacterNameValues } from '../Character';
import { CharacterName } from './../Character';
import { app } from '../core/App';
/* END-USER-IMPORTS */

export default class TaxiCard extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 125.5, y ?? 76.5);

    // taxiCard
    const taxiCard = scene.add.image(0, 0, "common", "taxi-card-tom.png");
    this.add(taxiCard);

    // line2
    const line2 = scene.add.text(-48, 18, "", {});
    line2.setOrigin(0.5, 0.5);
    line2.visible = false;
    line2.text = "Taxis";
    line2.setStyle({ "align": "center", "fixedHeight":40,"fontFamily": "FREDFREDBURGERHEADLINE-BLACK ", "fontSize": "36px" });
    this.add(line2);

    // line1
    const line1 = scene.add.text(-48, -28, "", {});
    line1.setOrigin(0.5, 0.5);
    line1.visible = false;
    line1.text = "Tom";
    line1.setStyle({ "align": "center", "fixedHeight":40,"fontFamily": "FREDFREDBURGERHEADLINE-BLACK ", "fontSize": "36px" });
    this.add(line1);

    // taxiName
    const taxiName = scene.add.text(-48, -6, "", {});
    taxiName.setOrigin(0.5, 0.5);
    taxiName.text = "Tom\nTaxis";
    taxiName.setStyle({ "align": "center", "fontFamily": "FREDFREDBURGERHEADLINE-BLACK ", "fontSize": "36px" });
    taxiName.setWordWrapWidth(120);
    this.add(taxiName);

    // line2 (components)
    const line2FitTextToBounds = new FitTextToBounds(line2);
    line2FitTextToBounds.maxWidth = 120;
    line2FitTextToBounds.maxHeight = 40;
    line2FitTextToBounds.minFontSize = 12;
    const line2LocaliseText = new LocaliseText(line2);
    line2LocaliseText.isDynamic = true;

    // line1 (components)
    const line1FitTextToBounds = new FitTextToBounds(line1);
    line1FitTextToBounds.maxWidth = 120;
    line1FitTextToBounds.maxHeight = 40;
    line1FitTextToBounds.minFontSize = 12;
    const line1LocaliseText = new LocaliseText(line1);
    line1LocaliseText.isDynamic = true;

    // taxiName (components)
    const taxiNameFitTextToBounds = new FitTextToBounds(taxiName);
    taxiNameFitTextToBounds.maxWidth = 120;
    taxiNameFitTextToBounds.maxHeight = 100;
    taxiNameFitTextToBounds.minFontSize = 12;
    taxiNameFitTextToBounds.multiLine = true;
    taxiNameFitTextToBounds.constrainByWidth = true;
    taxiNameFitTextToBounds.constrainByHeight = true;
    new LocaliseText(taxiName);

    this.taxiCard = taxiCard;
    this.line2 = line2;
    this.line1 = line1;
    this.taxiName = taxiName;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */

    // custom definition props
    this.cardOwner = "tom";
  }

  private taxiCard: Phaser.GameObjects.Image;
  private line2: Phaser.GameObjects.Text;
  private line1: Phaser.GameObjects.Text;
  private taxiName: Phaser.GameObjects.Text;
  public textRightPosX: number = 44;
  public textLeftPosX: number = -48;

  /* START-USER-CODE */
  protected cardOwner: CharacterNameValues;

  public changeOwner(newOwner: CharacterNameValues) {
    this.cardOwner = newOwner;
    this.taxiCard.setFrame(Character.cardLookup[newOwner]);

    switch (newOwner) {
      case CharacterName.Tom:
        this.taxiName.x = this.textLeftPosX;
        this.taxiName.text = app.localeHandler.getLocalisedTextById('tomTaxis');

        // this.line1.x = this.textLeftPosX;
        // this.line2.x = this.textLeftPosX;
        // this.line1.text = app.localeHandler.getLocalisedTextById('tom');
        // this.line2.text = app.localeHandler.getLocalisedTextById('taxis');
        // LocaliseText.getComponent(this.line1Left)
        break;
      case CharacterName.Jerry:
        this.taxiName.x = this.textRightPosX;
        this.taxiName.text = app.localeHandler.getLocalisedTextById('jerryCabs');

        // this.line1.x = this.textRightPosX;
        // this.line2.x = this.textRightPosX;
        // this.line1.text = app.localeHandler.getLocalisedTextById('jerry');
        // this.line2.text = app.localeHandler.getLocalisedTextById('cabs');
        break;
      case CharacterName.Spike:
        this.taxiName.x = this.textRightPosX;
        this.taxiName.text = app.localeHandler.getLocalisedTextById('speedySpike');

        // this.line1.x = this.textRightPosX;
        // this.line2.x = this.textRightPosX;
        // this.line1.text = app.localeHandler.getLocalisedTextById('speedy');
        // this.line2.text = app.localeHandler.getLocalisedTextById('spike');
        break;
      case CharacterName.Toots:
        this.taxiName.x = this.textLeftPosX;
        this.taxiName.text = app.localeHandler.getLocalisedTextById('tootsTrips');

        // this.line1.x = this.textLeftPosX;
        // this.line2.x = this.textLeftPosX;
        // this.line1.text = app.localeHandler.getLocalisedTextById('toots');
        // this.line2.text = app.localeHandler.getLocalisedTextById('trips');
        break;
      default:
        break;
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
